module.exports = __webpack_public_path__ + "60d1de682caca8094750f62de3c47b97.png";